module.exports = __webpack_public_path__ + "static/img/jia_xing.d10658c7.png";